import { computed, Directive, inject, input } from '@angular/core';
import { StationManagerService, TimelineSegmentItem } from '@splixer/player';
import { uString } from '@hidat/huijs-common';

/**
 * An attempt to staqndardize on the naming of shows and segments from a TimeloineSegmentItem,
 * as there are many places where we display the current segment, but with different formatting.
 */
@Directive()
export class ShowAndSegmentNamerController {
  public readonly item = input.required<TimelineSegmentItem | undefined>();
  protected station = inject(StationManagerService);

  protected hostConjunction = 'with';
  protected dateConjunction = 'from';

  protected mixNameFromTimeline(ts: TimelineSegmentItem): uString {
    let name: uString;
    if (ts.mix) {
      name = ts.mix.name;
    }
    return name;
  }

  protected showNameFromTimeline(ts: TimelineSegmentItem): uString {
    let name: uString;
    if (ts.show) {
      name = ts.show.name;
    }
    return name;
  }

  /**
   * Base function to pull out the name so you can tweak it in your computed.
   * @param ts
   * @protected
   */
  protected segmentNameFromTimeline(ts: TimelineSegmentItem): uString {
    let name: uString;
    if (ts.segment?.name) {
      name = ts.segment.name;
    } else if (ts.show?.name) {
      name = ts.show.name;
    }
    return name;
  }

  protected mixName = computed(() => {
    let name: uString;
    const ts = this.item();
    if (ts) {
      name = this.mixNameFromTimeline(ts);
    }
    return name;
  });

  protected hostName = computed(() => {
    let name: uString;
    const item = this.item();
    if (item?.host) {
      name = item.host.name;
    }
    return name;
  });

  protected imageUrl = computed(() => {
    let url = '/assets/default-mix-image-thumbnail.jpg';
    const item = this.item()?.mix;
    if (item) {
      if (item.imageUrl) {
        url = item.imageUrl;
      } else if (item._program?.imageUrl) {
        url = item._program.imageUrl;
      } else if (item._host?.imageUrl) {
        return item._host.imageUrl;
      }
    }
    return url;
  });

  protected broadcastedAt = computed(() => {
    const ts = this.item();
    if (ts) {
      if (ts.show?.startedAt) {
        return this.station.formatLongDate(ts.show.startedAt);
      }
    }
    return undefined;
  });

  protected showDescription = computed(() => {
    let name: uString;
    const ts = this.item();
    if (ts) {
      if (ts?.show) {
        name = ts.show.description ?? ts.show.tagLine;
      }
    }
    return name;
  });
}
